// extracted by mini-css-extract-plugin
module.exports = {"OptionsControl":"OptionsControl_OptionsControl__YxDZH","IconOptionsControl":"OptionsControl_IconOptionsControl__3kx-D"};